/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 权限策略状态管理
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-24
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { GroupPolicy } from '../global'
import actionTypes from '../constants/actionTypes'

interface AuthPolicyState {
  groupPolicyList: GroupPolicy[]
}

const initialState: AuthPolicyState = {
  groupPolicyList: []
}

const authPolicySlice = createSlice({
  name: 'authPolicy',
  initialState,
  reducers: {
    setGroupPolicyList: (state, action: PayloadAction<GroupPolicy[]>) => {
      state.groupPolicyList = action.payload
    }
  },
  extraReducers: (builder) => {
    // 兼容旧的 action type
    builder.addCase(
      actionTypes.SET_GROUP_POLICY_LIST,
      (state, action: PayloadAction<GroupPolicy[]>) => {
        state.groupPolicyList = action.payload
      }
    )
  }
})

export const { setGroupPolicyList } = authPolicySlice.actions

export default authPolicySlice.reducer
